/**
 * Count operators in the catalog that are not downloaded or have a newer published version.
 * Matches legacy mobile `updateOperatorBadgeCount` (string version compare).
 */
export function catalogVersionIsNewer(
  catalogVersion: string,
  cachedVersion: string,
): boolean {
  return catalogVersion > cachedVersion;
}

export type CatalogUpdateRow = {
  operatorId: string;
  currentVersion: string;
};

export type CachedVersionByOperatorId = Record<string, string | undefined>;

/** True when the row would show a Download button: not cached at current catalog version. */
export function catalogOperatorNeedsDownload(
  op: CatalogUpdateRow,
  cachedVersionByOperatorId: CachedVersionByOperatorId,
): boolean {
  const cached = cachedVersionByOperatorId[op.operatorId];
  if (cached === undefined) return true;
  return catalogVersionIsNewer(op.currentVersion, cached);
}

/** Badge count and Download All scope: never-downloaded + update-available. */
export function countCatalogUpdatesAvailable(
  catalog: CatalogUpdateRow[] | null | undefined,
  cachedVersionByOperatorId: CachedVersionByOperatorId,
): number {
  if (!catalog?.length) return 0;

  let count = 0;
  for (const op of catalog) {
    if (catalogOperatorNeedsDownload(op, cachedVersionByOperatorId)) {
      count += 1;
    }
  }
  return count;
}
